<!--
 * @Author: wangjx
 * @LastEditors: xiaona.wang
 * @Date: 2021-08-11 20:08:05
 * @LastEditTime: 2021-09-06 17:04:41
 * @Description: file content
-->
<template>
  <menu-list :is-sys="true"></menu-list>
</template>

<script>
import MenuList from "./menu-list.vue";

export default {
  name: "MenuListSys",
  components: {
    MenuList
  },
  data() {
    return {};
  },

  methods: {}
};
</script>
